import $ from "jquery";

import "./bootstrap/admin";
import "./modules/ajaxForm";
import "./modules/checkboxes";
import "./modules/countrySelect";
import "./modules/hcpSearch";
import "./modules/infoTooltips";
import "./modules/institution";
import "./modules/institutionInvite";
import "./modules/multiform";
import "./modules/pancakeNav";
import "./modules/selectSubmit";
import "./modules/tablesawInit";
import "./modules/backButton";
import "./modules/datepicker";
import "./modules/numberInput";

import DataTable from "./components/DataTable.vue";
import UserStatistics from "./components/UserStatistics.vue";
import DeleteButton from "./components/DeleteButton.vue";

import { createApp } from "vue";

const app = createApp({
    mounted() {
        $.holdReady(false);
    },
});

app.component("user-statistics", UserStatistics);
app.component("data-table", DataTable);
app.component("delete-button", DeleteButton);

app.mount("#app");
